import { useEffect, useState } from 'react';

export const useWindowDimensions = () => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);

    const getSizes = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('load', getSizes);
    window.addEventListener('resize', getSizes);
    return () => {
      window.removeEventListener('resize', getSizes);
      window.removeEventListener('load', getSizes);
    };
  }, []);

  return {
    windowWidth,
    windowHeight,
  };
};
